import api from './api';

const ENDPOINT = 'banners';

const BannerService = {
  get: () => api.get(ENDPOINT),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  getByNetwork: (networkId) =>
    api.get(`${ENDPOINT}/get-by-network`, { params: { networkId } }),
  getLoginBanners: () => api.get(`${ENDPOINT}/get-login-banners`),
};

export default BannerService;
